
import { useContext, useEffect, useRef, useState } from "react";
import { isMobile, isTablet } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';

import { AppColors } from "../../../Global/StyledComponents/Graphics";
import {
    CTAButton,
    CardGridModalWrapper,
    CenteredDiv,
    StockCardGrid
} from "../../../Global/StyledComponents/AppStyledComponents";
import { DefaultSort } from "../../../Global/constants";
import { Header } from "../../../Global/StyledComponents/UserFormStyledComponents";
import Loading from "../../../Global/Components/LoadingSpinner";
import Pagination from "../../../Global/Components/PaginationFooter";
import { StateContext } from "../../../Controllers/context/state";
import StockCardView from '../../../Global/Views/StockCardView/StockCardView';
import supabase from "../../../Controllers/utils/supabaseClient";

const IndustryPeersPopUp = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const limit = 50;
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [offSet, setOffset] = useState(0);
    const [paginatedList, setPaginatedList] = useState([]);
    const scrollRef = useRef();
    const [tickerList, setTickerList] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const {
        expandedViewTicker,
        logError,
        sectorOptions,
        setEtfConstituents,
        setFilter,
        setSelectedScreener,
        setShowIndustryPeers,
        setSort,
    } =  useContext(StateContext);

    useEffect(() => {
        const fetchData = () => {
            setLoading(true);

            supabase.rpc('getfilteredsortedlist', { request: {
                filter: {
                    sectorOptions,
                    summary: "dtm_summary NOTNULL",
                },
                sort: DefaultSort,
            }}).then((res) => {
                if (res?.error) {
                    const error = new Error(res?.error?.message);
                    logError(error.message, undefined, error);

                    setLoading(false);
                    setShowIndustryPeers(false);
        
                    return;
                }
    
                const entities = res?.data?.[0]?.symbol?.entities;
                const nextEntities = Array.isArray(entities) ? entities : [];

                setTickerList(nextEntities);
                setPaginatedList(nextEntities.slice(offSet, (offSet + limit)));
                setTotalPages(Math.ceil(nextEntities.length / limit));
                setLoading(false);
            });
        };

        fetchData();
    }, [expandedViewTicker]);

    useEffect(() => {
        setPaginatedList(tickerList.slice(offSet, (offSet + limit)))
    }, [offSet]);

    const handleOpenScreener = () => {
        setSelectedScreener(null);
        setFilter({ sectorOptions });
        setSort(DefaultSort);
        setEtfConstituents(null);
        setShowIndustryPeers(false);
        navigate('/screener');
    };

    const firstPage = () => {
        setCurrentPage(1);
        setOffset(0);
        scrollRef?.current?.scrollTo(0, 0);
    };

    const lastPage = () => {
        setCurrentPage(totalPages);
        setOffset((limit * totalPages) - limit);
        scrollRef?.current?.scrollTo(0, 0);
    };

    const nextPage = () => {
        setCurrentPage(prevState => prevState += 1);
        setOffset(prevState => prevState += limit);
        scrollRef?.current?.scrollTo(0, 0);
    };

    const prevPage = () => {
        setCurrentPage(prevState => prevState -= 1);
        setOffset(prevState => prevState -= limit);
        scrollRef?.current?.scrollTo(0, 0);
    };

    return (
        <CardGridModalWrapper>
            <Header style={{ paddingTop: (!isMobile || isTablet ) ? null : 30}}>
                Industry Peers of {expandedViewTicker}
            </Header>
            <StockCardGrid ref={scrollRef} style={{ height: (!isMobile || isTablet ) ? '90%' : '75%' }}>
                {loading ?
                    <Loading /> :
                    (paginatedList?.length ?
                        <StockCardView readOnly tickerList={paginatedList} /> :
                        <CenteredDiv style={{ padding: (!isMobile || isTablet) ? null : '20px' }}>
                            No insights available.
                        </CenteredDiv>
                    )
                }
            </StockCardGrid>
            {totalPages > 1 &&
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        firstPage={firstPage}
                        lastPage={lastPage}
                        nextPage={nextPage}
                        prevPage={prevPage}
                    />
                </div>
            }
            <CTAButton onClick={handleOpenScreener} style={{ top: -20, color: 'white', background: AppColors.MRNAVY40, position: 'absolute', left: 0, width: 'fit-content' }}>
                Open In Screener
            </CTAButton>
        </CardGridModalWrapper>
    )
};

export default IndustryPeersPopUp;
